"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lessona": {
    "8897def9": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "skipSearch": false
    }],
    "barale": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04f782cc": [{
      "hkey": "000dd911",
      "slug": "capovilla-castello",
      "name": "Capovilla-Castello",
      "primary": true,
      "skipSearch": false
    }],
    "capovilla": [{
      "hkey": "000dd911",
      "slug": "capovilla-castello",
      "name": "Capovilla-Castello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3f571baa": [{
      "hkey": "ee4f918b",
      "slug": "palazzina-casetti",
      "name": "Palazzina-Casetti",
      "primary": true,
      "skipSearch": false
    }],
    "casetti": [{
      "hkey": "ee4f918b",
      "slug": "palazzina-casetti",
      "name": "Palazzina-Casetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lessona"
    }],
    "fb7ad2e9": [{
      "hkey": "000dd911",
      "slug": "capovilla-castello",
      "name": "Capovilla-Castello",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "000dd911",
      "slug": "capovilla-castello",
      "name": "Capovilla-Castello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lessona"
    }],
    "6638fa72": [{
      "hkey": "e6b748e8",
      "slug": "crosa-villa",
      "name": "Crosa-Villa",
      "primary": true,
      "skipSearch": false
    }],
    "crosa": [{
      "hkey": "e6b748e8",
      "slug": "crosa-villa",
      "name": "Crosa-Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2bec7c23": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "skipSearch": false
    }],
    "fabbriche": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40de4f00": [{
      "hkey": "43338004",
      "slug": "ratina-fiora",
      "name": "Ratina-Fiora",
      "primary": true,
      "skipSearch": false
    }],
    "fiora": [{
      "hkey": "43338004",
      "slug": "ratina-fiora",
      "name": "Ratina-Fiora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lessona"
    }],
    "f8772f24": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "skipSearch": false
    }],
    "foglia": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2cb75ae": [{
      "hkey": "ee4f918b",
      "slug": "palazzina-casetti",
      "name": "Palazzina-Casetti",
      "primary": true,
      "skipSearch": false
    }],
    "palazzina": [{
      "hkey": "ee4f918b",
      "slug": "palazzina-casetti",
      "name": "Palazzina-Casetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8cad1f8b": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "skipSearch": false
    }],
    "piccone": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2765825f": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-guelpa": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d6b66e1f": [{
      "hkey": "43338004",
      "slug": "ratina-fiora",
      "name": "Ratina-Fiora",
      "primary": true,
      "skipSearch": false
    }],
    "ratina": [{
      "hkey": "43338004",
      "slug": "ratina-fiora",
      "name": "Ratina-Fiora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3a3f8911": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "6b1ddb21",
      "slug": "lessona",
      "name": "Lessona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;